import { Constants } from "../../globals/constants";
import { Nullable } from "../../globals/types";
import { RootStoreSession } from "../root-store";
import { CreationArea } from "./area";

export async function updateUninitializedCreationStatus(rootStoreSession: RootStoreSession) {
    const creationAreasWithoutCreationStatus = rootStoreSession.areaStore.creationAreas.filter(a => a.areaDto.creationStatus === null);
    await updateCreationStatus(creationAreasWithoutCreationStatus, rootStoreSession);
}

export async function updateCreationStatus(creationAreas: CreationArea[], rootStoreSession: RootStoreSession) {
    function mapStatus(projectStatus: string, creationStatus: Nullable<string>): string {
        const statusMapping = new Map<string, string>();
        statusMapping.set("in_bearbeitung", "in_bearbeitung");
        statusMapping.set("noch_nicht_in_Kraft", "bewilligt");
        statusMapping.set("in_kraft", "bewilligt");
        statusMapping.set("sistiert", "sistiert");

        if (statusMapping.has(projectStatus)) {
            return statusMapping.get(projectStatus)!;
        }

        if (creationStatus === null) {
            return "in_bearbeitung";
        }

        return creationStatus;
    }

    for (const area of creationAreas) {
        let projectStatus = "";
        let creationProject = rootStoreSession.projectStore.creationProjects.find(p => p.id === area.projectId);

        if (creationProject === undefined) {
            try {
                creationProject = await rootStoreSession.projectStore.loadCreationProject(area.projectId);
            } catch {
                // Skip if creation area has no associated creation project
                break;
            }
        }

        projectStatus = creationProject.projectDto.status;

        if (creationProject.typeKey === Constants.projectTypeRecultivation) {
            let compensation = rootStoreSession.compensationStore.compensations.find(c => c.creationProjectId === creationProject.id);

            if (compensation === undefined) {
                compensation = (await rootStoreSession.compensationStore.loadWithOptions({ creationProjectId: creationProject.id }))[0];
            }

            let usageProject = rootStoreSession.projectStore.usageProjects.find(p => p.id === compensation.usageProjectId);

            if (usageProject === undefined) {
                usageProject = await rootStoreSession.projectStore.loadUsageProject(compensation.usageProjectId);
            }

            projectStatus = usageProject.projectDto.status;
        }

        const newCreationStatus = mapStatus(projectStatus, area.areaDto.creationStatus);
        area.areaDto = { ...area.areaDto, creationStatus: newCreationStatus };
        await rootStoreSession.areaStore.updateCreationArea(area.areaDto);
    }
}